import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import './i18n';

// Ensure root div fills full viewport
document.getElementById('root').style.display = 'flex';
document.getElementById('root').style.flexDirection = 'column';
document.getElementById('root').style.minHeight = '100vh';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);